import * as React from 'react';
import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteRight } from '@fortawesome/free-solid-svg-icons';

export const QuoteIcon = (): ReactNode => <FontAwesomeIcon icon={faQuoteRight}/>;
